var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.45 26.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1fba9c;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tipp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.61,11.75v0a6.56,6.56,0,0,1-.34-1,7.61,7.61,0,0,1-.27-2,7.73,7.73,0,0,1,15.45,0A7.61,7.61,0,0,1,16.12,11h0v0c-.05.15-.1.3-.16.44h0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.12 10.97 16.12 10.98 16.11 11.02 15.96 11.46 15.96 11.47 13.71 16.48 12.95 20.16 4.51 21.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.88 18.33 3.76 16.48 1.61 11.75 1.61 11.73 1.27 10.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.65,
    y1: 23.74,
    x2: 12.08,
    y2: 22.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.95,
    y1: 26,
    x2: 10.77,
    y2: 25.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.15,13.5v-.3a1.39,1.39,0,0,0-.36-.94,1.3,1.3,0,0,0-.23-.18,1.22,1.22,0,0,0-.67-.2A1.3,1.3,0,0,0,6.61,13.2v5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,18.21v-5a1.35,1.35,0,0,0-.37-.94,1.28,1.28,0,0,0-.9-.38,1.18,1.18,0,0,0-.67.2A1.33,1.33,0,0,0,8,13.2v.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,13.44v.12a.6.6,0,0,0,1.19-.06"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipGreen);
export default __webpack_public_path__ + "static/media/tipGreen.6034dcb48c9b856873cbb2cb07a68a50.svg";
export { ForwardRef as ReactComponent };